/**
 * /frontend/src/features/analytics/api/abandonmentAnalyticsApi.js
 */

import { ANALYTICS_ENDPOINTS } from '../constants/analyticsEndpoints';
import { getJson } from './analyticsApiClient';

/**
 * Fetches abandonment summary KPIs.
 */
export const getAbandonmentSummary = async (request, token, storeId, startDate, endDate) => getJson(
  request,
  ANALYTICS_ENDPOINTS.ABANDONMENT_SUMMARY,
  { storeId, startDate, endDate },
  token,
  'analytics-abandonment-summary'
);

/**
 * Fetches abandonment by section.
 */
export const getAbandonmentBySection = async (request, token, storeId, startDate, endDate) => getJson(
  request,
  ANALYTICS_ENDPOINTS.ABANDONMENT_BY_SECTION,
  { storeId, startDate, endDate },
  token,
  'analytics-abandonment-by-section'
);

/**
 * Fetches abandonment trend.
 */
export const getAbandonmentTrend = async (request, token, storeId, startDate, endDate, granularity) => getJson(
  request,
  ANALYTICS_ENDPOINTS.ABANDONMENT_TREND,
  { storeId, startDate, endDate, granularity },
  token,
  'analytics-abandonment-trend'
);

